import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      showNoLiBPrompt: false,
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    ...mapGetters({
      expectedDeliveryDates: 'purchaseOrder/expectedDeliveryDates',
    }),
    expectedDeliveryDatesEnabled() {
      return this.dealerSettings.showDeliveryDates
    },
    expectedDeliveryDateUnknown() {
      let allDatesSame = true
      if (!!this.expectedDeliveryDates) {
        const expectedDeliveryDateValues = Object.values(this.expectedDeliveryDates)
        let i = 1
        while (allDatesSame && i < expectedDeliveryDateValues.length) {
          allDatesSame = moment
            .utc(expectedDeliveryDateValues[i])
            .isSame(moment.utc(expectedDeliveryDateValues[i - 1]), 'day')
          i++
        }
      }

      return allDatesSame
    },
    expectedDeliveryDateUnknownAndForced() {
      return this.expectedDeliveryDateUnknown && this.dealerSettings.showDeliveryDates
    },
  },
  methods: {
    expectedDeliveryDateCheck() {
      if (this.expectedDeliveryDatesEnabled && this.expectedDeliveryDateUnknownAndForced) {
        this.showNoLiBPrompt = true
        return false
      }
      return true
    },
  },
}
